import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import type { ProductImages as ProductImagesType } from "stores/product";
import s from "components/ProductConfigurator/ProductConfigurator.module.scss";
import { ProductImage } from "components/ProductImage";

export const ResultsProductImage = Scrivito.connect(
  ({
    defaultImage,
    image,
    width,
    height,
    productName,
    disabled,
  }: {
    defaultImage?: Scrivito.Obj;
    image?: NonNullable<ProductImagesType[number]>;
    width: number;
    height: number;
    productName: string;
    disabled?: boolean;
  }) => {
    if (!image?.pimId && !defaultImage) {
      return null;
    }
    return image && "pimId" in image && image.pimId !== null ? (
      <>
        <ProductImage
          pimId={image.pimId}
          width={width}
          height={height}
          productName={productName}
        />
        <div className={s.imageCardImageLabel}>{image?.text}</div>
      </>
    ) : (
      defaultImage && (
        <Scrivito.ImageTag
          className={cx(
            "img-fluid w-100 h-100",
            {
              "opacity-25": disabled,
            },
            s.imageCardImage,
          )}
          content={defaultImage}
        />
      )
    );
  },
);
